/* INDRI – home hero "window": the video is a fixed background and the heading card stays in
   place while the hero band scrolls over them; the card dissolves on the way down and comes
   back on the way up. Home page only. */
(() => {
  const main = document.querySelector('#MainContent[data-template="index"]');
  if (!main) return;
  const section = main.querySelector(':scope > .shopify-section:first-child');
  const hero = section && section.querySelector('.hero');
  const card = hero && hero.querySelector('.hero__content-wrapper');
  if (!hero || !card) return;

  section.classList.add('indri-hero-window');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
  section.classList.add('indri-hero-window--motion');

  const pageWrapper = document.querySelector('.page-wrapper');
  // The theme scrolls .page-wrapper on wide screens and the document on narrow ones.
  const scrollTop = () => Math.max(document.scrollingElement.scrollTop, pageWrapper ? pageWrapper.scrollTop : 0);
  const smooth = (a, b, x) => {
    const t = Math.min(Math.max((x - a) / (b - a), 0), 1);
    return t * t * (3 - 2 * t);
  };

  let frame = null;
  const update = () => {
    frame = null;
    const h = hero.offsetHeight || 1;
    const s = Math.min(scrollTop(), h);
    // the strip is gone after a short scroll, well before the band itself leaves
    const fade = 1 - smooth(0.02, 0.22, s / h);
    // counter the scroll so the card stays where it is, like the video behind it
    card.style.setProperty('--indri-card-pin', `${s.toFixed(1)}px`);
    card.style.setProperty('--indri-card-fade', fade.toFixed(3));
    card.style.pointerEvents = fade < 0.15 ? 'none' : '';
  };
  const request = () => {
    if (frame === null) frame = requestAnimationFrame(update);
  };

  update();
  document.addEventListener('scroll', request, { capture: true, passive: true });
  window.addEventListener('resize', request);
})();
